import { render } from "./AppearanceCard.vue?vue&type=template&id=94b93a4c&scoped=true"
import script from "./AppearanceCard.vue?vue&type=script&lang=js"
export * from "./AppearanceCard.vue?vue&type=script&lang=js"

import "./AppearanceCard.vue?vue&type=style&index=0&id=94b93a4c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-94b93a4c"]])

export default __exports__